var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{domProps:{"innerHTML":_vm._s(require(`SVGPATH/${_vm.icon}.svg`))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }